import {
  Form,
  Space,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { editStationService, getStationByIdService } from '../../../../services/admin/stationServices';
import StationForm from '../../forms/StationForm';

function EditStation() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);

  const getStationData = async () => {
    const res = await getStationByIdService(id);
    if (res?.status === 'success') {
      form.setFieldsValue(res.data);
    }
  };

  useEffect(() => {
    getStationData();
  }, []);

  const onFinish = async (values) => {
    setIsLoading(true);
    try {
      const res = await editStationService(id, values);
      if (res?.status === 'success') {
        navigate('/admin/stations');
      } else {
        setErrors(res?.errors);
      }
    } catch (error) {
      if (error?.response?.data?.errors) {
        setErrors(error?.response?.data?.errors);
      }
    }
    setIsLoading(false);
  };

  return (
    <Space size="large" direction="vertical" style={{ width: '100%' }}>
      <ArrowLeftOutlined
        style={{ fontSize: '20px' }}
        onClick={() => navigate('/admin/stations')}
      />
      <StationForm
        form={form}
        onFinish={onFinish}
        errors={errors}
        isLoading={isLoading}
      />
    </Space>
  );
}

export default EditStation;
